/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "backbone",
    "underscore",
    "service/stub",
    "service/factory",
    "client/localized_model",
    "service/cross_domain_ajax_channel"
  ], function(
    Backbone,
    _,
    Stub,
    ServiceFactory,
    LocalizedModel,
    CrossDomainAjaxChannel
  ) {

var Notification = {};

Notification.Model = LocalizedModel.extend({ });

Notification.NotificationCollection = Backbone.Collection.extend({

  model: Notification.Model,
  fetch: function (url, options, channelOptions) {
    if (options.enableAllNotifications === false) return false;
    var that = this;
    var optionsClone = _.clone(options || {});
    if (optionsClone.parse === void 0) optionsClone.parse = true;

    var responseObserver = _.extend({}, Backbone.Events);
    responseObserver.on("response", function (response, url) {
      response.id = url.id;
      response.channelOptions = channelOptions;
      that.response = response;
      that.add(response, optionsClone);
    });
    responseObserver.on("error", function (error) {
      console.error(error);
    });

    var stub = new NotificationServiceStub();
    var channel = new CrossDomainAjaxChannel({ url: url }, channelOptions);
    stub.cast(channel, null, responseObserver);
  }
});

var NotificationServiceStub = Notification.NotificationServiceStub = Stub.extend({
  path: "../../api/mindbreeze.client.notification.v1",
  options: { method: "GET" },
});

var NotificationServiceFactory = Notification.ServiceFactory = function() {}

_.extend(NotificationServiceFactory.prototype, ServiceFactory.prototype, {
  cast: function (channel) {
    new NotificationServiceStub().cast(channel);
   },

   getNotificationPath: function () {
     return new NotificationServiceStub().path;
   }

});
    return Notification;
});
